// extracted by mini-css-extract-plugin
module.exports = {"dashStyle":"AddChild_dashStyle__aqEWr"};